// extracted by mini-css-extract-plugin
export default {"block":"ne","flex":"oe","radio":"pe","label":"qe","error":"re","extra":"se"};